/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { useSettingsContext } from '../SettingsProvider'
import { NumberInput, NumberInputProps } from '@mantine/core'

export type PriceInputProps = NumberInputProps & { currency?: string }

function PriceInput (props: PriceInputProps) {
  const {
    currency,
    label,
    name = 'price',
    ...others
  } = props
  const intl = useIntl()
  const { settings } = useSettingsContext()
  const suffix = (currency || settings.CURRENCY)
  return (
    <NumberInput
      label={label || intl.formatMessage({
        id: 'price',
        defaultMessage: 'Prix'
      })}
      name={name}
      suffix={suffix != null ? ' ' + suffix : undefined}
      decimalSeparator=","
      thousandSeparator=" "
      {...others}
    />
  )
}

export default PriceInput
